/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const DefaultPicture: React.SFC = () => {
    return (
        <svg width="36" height="36" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
            <defs><circle id="a" cx="20" cy="20" r="20" /></defs>
            <g fill="none" fillRule="evenodd"><mask id="b" fill="#fff"><use xlinkHref="#a" /></mask>
                <g strokeLinecap="square"><use fill="#555A77" xlinkHref="#a" />
                    <circle stroke="#FFF" cx="20" cy="20" r="20.5" /></g>
                <circle fill="#31374F" mask="url(#b)" cx="20" cy="17" r="7" />
                <path d="M20 40.65c7.18 0 13 4.3 13-2.443C33 31.465 27.18 26 20 26S7 31.465 7 38.207c0 6.742 5.82 2.442 13 2.442z" fill="#31374F" mask="url(#b)" />
            </g></svg>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/DefaultPicture/DefaultPicture.tsx